 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9780062693457_COVER from '@/components/text/9780062693457_Cover'
 import LOVE_1 from '@/components/love_1'
 import TEXT9780062693457_TITLEPAGE from '@/components/text/9780062693457_Titlepage'
 import TEXT9780062693457_DEDICATION from '@/components/text/9780062693457_Dedication'
 import TEXT9780062693457_CONTENTS from '@/components/text/9780062693457_Contents'
 import TEXT9780062693457_PROLOGUE from '@/components/text/9780062693457_Prologue'
 import TEXT9780062693457_CHAPTER_1 from '@/components/text/9780062693457_Chapter_1'
 import TEXT9780062693457_CHAPTER_2 from '@/components/text/9780062693457_Chapter_2'
 import TEXT9780062693457_CHAPTER_3 from '@/components/text/9780062693457_Chapter_3'
 import TEXT9780062693457_CHAPTER_4 from '@/components/text/9780062693457_Chapter_4'
 import TEXT9780062693457_CHAPTER_5 from '@/components/text/9780062693457_Chapter_5'
 import TEXT9780062693457_CHAPTER_6 from '@/components/text/9780062693457_Chapter_6'
 import TEXT9780062693457_CHAPTER_7 from '@/components/text/9780062693457_Chapter_7'
 import TEXT9780062693457_CHAPTER_8 from '@/components/text/9780062693457_Chapter_8'
 import TEXT9780062693457_CHAPTER_9 from '@/components/text/9780062693457_Chapter_9'
 import TEXT9780062693457_CHAPTER_10 from '@/components/text/9780062693457_Chapter_10'
 import TEXT9780062693457_CHAPTER_11 from '@/components/text/9780062693457_Chapter_11'
 import TEXT9780062693457_CHAPTER_12 from '@/components/text/9780062693457_Chapter_12'
 import TEXT9780062693457_CHAPTER_13 from '@/components/text/9780062693457_Chapter_13'
 import TEXT9780062693457_CHAPTER_14 from '@/components/text/9780062693457_Chapter_14'
 import TEXT9780062693457_CHAPTER_15 from '@/components/text/9780062693457_Chapter_15'
 import TEXT9780062693457_CHAPTER_16 from '@/components/text/9780062693457_Chapter_16'
 import TEXT9780062693457_CHAPTER_17 from '@/components/text/9780062693457_Chapter_17'
 import TEXT9780062693457_CHAPTER_18 from '@/components/text/9780062693457_Chapter_18'
 import TEXT9780062693457_CHAPTER_19 from '@/components/text/9780062693457_Chapter_19'
 import TEXT9780062693457_CHAPTER_20 from '@/components/text/9780062693457_Chapter_20'
 import TEXT9780062693457_CHAPTER_21 from '@/components/text/9780062693457_Chapter_21'
 import TEXT9780062693457_CHAPTER_22 from '@/components/text/9780062693457_Chapter_22'
 import TEXT9780062693457_CHAPTER_23 from '@/components/text/9780062693457_Chapter_23'
 import TEXT9780062693457_CHAPTER_24 from '@/components/text/9780062693457_Chapter_24'
 import TEXT9780062693457_CHAPTER_25 from '@/components/text/9780062693457_Chapter_25'
 import TEXT9780062693457_CHAPTER_26 from '@/components/text/9780062693457_Chapter_26'
 import TEXT9780062693457_CHAPTER_27 from '@/components/text/9780062693457_Chapter_27'
 import TEXT9780062693457_CHAPTER_28 from '@/components/text/9780062693457_Chapter_28'
 import TEXT9780062693457_CHAPTER_29 from '@/components/text/9780062693457_Chapter_29'
 import TEXT9780062693457_CHAPTER_30 from '@/components/text/9780062693457_Chapter_30'
 import TEXT9780062693457_CHAPTER_31 from '@/components/text/9780062693457_Chapter_31'
 import TEXT9780062693457_CHAPTER_32 from '@/components/text/9780062693457_Chapter_32'
 import TEXT9780062693457_EPILOGUE from '@/components/text/9780062693457_Epilogue'
 import LOVE_2 from '@/components/love_2'
 import TEXT9780062693457_AUTHORS_NOTE from '@/components/text/9780062693457_Authors_Note'
 import TEXT9780062693457_PS from '@/components/text/9780062693457_PS'
 import TEXT9780062693457_PS_ABOUT_THE_AUTHOR from '@/components/text/9780062693457_PS_About_the_Author'
 import TEXT9780062693457_PS_ABOUT_THE_BOOK from '@/components/text/9780062693457_PS_About_the_Book'
 import TEXT9780062693457_PS_ABOUT_THE_BOOK1 from '@/components/text/9780062693457_PS_About_the_Book1'
 import TEXT9780062693457_PS_ABOUT_THE_BOOK2 from '@/components/text/9780062693457_PS_About_the_Book2'
 import TEXT9780062693457_ALSO_BY from '@/components/text/9780062693457_Also_by'
 import TEXT9780062693457_BA from '@/components/text/9780062693457_BA'
 import TEXT9780062693457_COPYRIGHT from '@/components/text/9780062693457_Copyright'
 import TEXTABOUT_THE_PUBLISHER from '@/components/text/About_the_Publisher'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/9780062693457_Cover",
 			"name" : "text/9780062693457_Cover",
 			"component" : TEXT9780062693457_COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/text/9780062693457_Titlepage",
 			"name" : "text/9780062693457_Titlepage",
 			"component" : TEXT9780062693457_TITLEPAGE
 		},
 		{
 			"path" : "/text/9780062693457_Dedication",
 			"name" : "text/9780062693457_Dedication",
 			"component" : TEXT9780062693457_DEDICATION
 		},
 		{
 			"path" : "/text/9780062693457_Contents",
 			"name" : "text/9780062693457_Contents",
 			"component" : TEXT9780062693457_CONTENTS
 		},
 		{
 			"path" : "/text/9780062693457_Prologue",
 			"name" : "text/9780062693457_Prologue",
 			"component" : TEXT9780062693457_PROLOGUE
 		},
 		{
 			"path" : "/text/9780062693457_Chapter_1",
 			"name" : "text/9780062693457_Chapter_1",
 			"component" : TEXT9780062693457_CHAPTER_1
 		},
 		{
 			"path" : "/text/9780062693457_Chapter_2",
 			"name" : "text/9780062693457_Chapter_2",
 			"component" : TEXT9780062693457_CHAPTER_2
 		},
 		{
 			"path" : "/text/9780062693457_Chapter_3",
 			"name" : "text/9780062693457_Chapter_3",
 			"component" : TEXT9780062693457_CHAPTER_3
 		},
 		{
 			"path" : "/text/9780062693457_Chapter_4",
 			"name" : "text/9780062693457_Chapter_4",
 			"component" : TEXT9780062693457_CHAPTER_4
 		},
 		{
 			"path" : "/text/9780062693457_Chapter_5",
 			"name" : "text/9780062693457_Chapter_5",
 			"component" : TEXT9780062693457_CHAPTER_5
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js